import { render, staticRenderFns } from "./MegaMenuInfo.vue?vue&type=template&id=48a9e6f3&scoped=true"
import script from "./MegaMenuInfo.vue?vue&type=script&lang=js"
export * from "./MegaMenuInfo.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuInfo.vue?vue&type=style&index=0&id=48a9e6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9e6f3",
  null
  
)

export default component.exports